/**
 * withArticles
 * HOC for wrapping the provided component with ArticlesProvider
 */

import React from 'react'

import ArticlesCategoriesProvider from './articles-categories-provider'

export default function withArticlesCategories(WrappedComponent) {
  return function ArticlesCategoriesProviderHOC(props) {
    return (
      <ArticlesCategoriesProvider>
        <WrappedComponent {...props} />
      </ArticlesCategoriesProvider>
    )
  }
}
